import styled from 'styled-components';
import { Box } from '../Box';
const BoxCompat = Box;
export const HFlex = styled(BoxCompat).attrs(() => ({
  display: 'flex',
  flexDirection: 'row'
})).withConfig({
  displayName: "Box__HFlex"
})([""]);
export const HGrid = styled(BoxCompat).attrs(_ref => {
  var _ref2;
  let {
    gap,
    gridAutoColumns,
    jc,
    justifyContent
  } = _ref;
  return {
    display: 'grid',
    gap: gap !== null && gap !== void 0 ? gap : 2,
    gridAutoColumns: gridAutoColumns !== null && gridAutoColumns !== void 0 ? gridAutoColumns : 'max-content',
    gridAutoFlow: 'column',
    justifyContent: (_ref2 = justifyContent !== null && justifyContent !== void 0 ? justifyContent : jc) !== null && _ref2 !== void 0 ? _ref2 : 'start'
  };
}).withConfig({
  displayName: "Box__HGrid"
})([""]);
export const VFlex = styled(BoxCompat).attrs(() => ({
  display: 'flex',
  flexDirection: 'column'
})).withConfig({
  displayName: "Box__VFlex"
})([""]);
export const VGrid = styled(BoxCompat).attrs(_ref3 => {
  var _ref4;
  let {
    gap,
    gridAutoRows,
    jc,
    justifyContent
  } = _ref3;
  return {
    display: 'grid',
    gap: gap !== null && gap !== void 0 ? gap : 2,
    gridAutoFlow: 'row',
    gridAutoRows: gridAutoRows !== null && gridAutoRows !== void 0 ? gridAutoRows : 'max-content',
    justifyContent: (_ref4 = justifyContent !== null && justifyContent !== void 0 ? justifyContent : jc) !== null && _ref4 !== void 0 ? _ref4 : 'start'
  };
}).withConfig({
  displayName: "Box__VGrid"
})([""]);
//# sourceMappingURL=Box.js.map